function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
!function (n, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.sift = t() : n.sift = t();
}(this, function () {
  return function (n) {
    var t = {};
    function r(e) {
      if (t[e]) return t[e].exports;
      var o = t[e] = {
        i: e,
        l: !1,
        exports: {}
      };
      return n[e].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }
    return r.m = n, r.c = t, r.d = function (n, t, e) {
      r.o(n, t) || Object.defineProperty(n, t, {
        enumerable: !0,
        get: e
      });
    }, r.r = function (n) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(n, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(n, "__esModule", {
        value: !0
      });
    }, r.t = function (n, t) {
      if (1 & t && (n = r(n)), 8 & t) return n;
      if (4 & t && "object" == _typeof(n) && n && n.__esModule) return n;
      var e = Object.create(null);
      if (r.r(e), Object.defineProperty(e, "default", {
        enumerable: !0,
        value: n
      }), 2 & t && "string" != typeof n) for (var o in n) r.d(e, o, function (t) {
        return n[t];
      }.bind(null, o));
      return e;
    }, r.n = function (n) {
      var t = n && n.__esModule ? function () {
        return n.default;
      } : function () {
        return n;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (n, t) {
      return Object.prototype.hasOwnProperty.call(n, t);
    }, r.p = "", r(r.s = 0);
  }([function (n, t, r) {
    n.exports = r(1);
  }, function (n, t, r) {
    "use strict";

    function e(n) {
      return (e = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (n) {
        return _typeof(n);
      } : function (n) {
        return n && "function" == typeof Symbol && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : _typeof(n);
      })(n);
    }
    function o(n) {
      var t = "[object " + n + "]";
      return function (n) {
        return Object.prototype.toString.call(n) === t;
      };
    }
    r.r(t), r.d(t, "default", function () {
      return m;
    }), r.d(t, "compare", function () {
      return j;
    }), r.d(t, "comparable", function () {
      return O;
    });
    var u = o("Array"),
      i = o("Object"),
      f = o("Function");
    function c(n, t) {
      return f(n.get) ? n.get(t) : n[t];
    }
    function a(n) {
      return function (t, r) {
        if (!u(r) || !r.length) return n(t, r);
        for (var e = 0, o = r.length; e < o; e++) if (n(t, c(r, e))) return !0;
        return !1;
      };
    }
    function l(n) {
      return function (t, r) {
        if (!u(r) || !r.length) return n(t, r);
        for (var e = 0, o = r.length; e < o; e++) if (!n(t, c(r, e))) return !1;
        return !0;
      };
    }
    function p(n, t, r, e) {
      return n.validate(n.options, t, r, e);
    }
    var s = {
        $eq: a(function (n, t) {
          return n(t);
        }),
        $ne: l(function (n, t) {
          return n(t);
        }),
        $gt: a(function (n, t) {
          return n(t);
        }),
        $gte: a(function (n, t) {
          return n(t);
        }),
        $lt: a(function (n, t) {
          return n(t);
        }),
        $lte: a(function (n, t) {
          return n(t);
        }),
        $mod: a(function (n, t) {
          return n(t);
        }),
        $in: function $in(n, t) {
          return n(t);
        },
        $nin: function $nin(n, t) {
          return n(t);
        },
        $not: function $not(n, t, r, e) {
          return n(t, r, e);
        },
        $type: function $type(n, t) {
          return n(t);
        },
        $all: function $all(n, t, r, e) {
          return s.$and(n, t, r, e);
        },
        $size: function $size(n, t) {
          return !!t && n === t.length;
        },
        $or: function $or(n, t, r, e) {
          for (var o = 0, u = n.length; o < u; o++) if (p(c(n, o), t, r, e)) return !0;
          return !1;
        },
        $nor: function $nor(n, t, r, e) {
          return !s.$or(n, t, r, e);
        },
        $and: function $and(n, t, r, e) {
          for (var o = 0, u = n.length; o < u; o++) if (!p(c(n, o), t, r, e)) return !1;
          return !0;
        },
        $regex: a(function (n, t) {
          return "string" == typeof t && n.test(t);
        }),
        $where: function $where(n, t, r, e) {
          return n.call(t, t, r, e);
        },
        $elemMatch: function $elemMatch(n, t, r, e) {
          return u(t) ? !!~function (n, t) {
            for (var r = 0; r < n.length; r++) {
              c(n, r);
              if (p(t, c(n, r))) return r;
            }
            return -1;
          }(t, n) : p(n, t, r, e);
        },
        $exists: function $exists(n, t, r, e) {
          return e.hasOwnProperty(r) === n;
        }
      },
      g = {
        $eq: function $eq(n, t, r) {
          var e = r.comparable,
            o = r.compare;
          return n instanceof RegExp ? a(function (t) {
            return "string" == typeof t && n.test(t);
          }) : n instanceof Function ? a(n) : u(n) && !n.length ? a(function (n) {
            return u(n) && !n.length;
          }) : a(null === n ? function (n) {
            return null == n;
          } : function (t) {
            return 0 === o(e(t), e(n));
          });
        },
        $gt: function $gt(n, t, r) {
          var e = r.comparable,
            o = r.compare;
          return function (t) {
            return o(e(t), e(n)) > 0;
          };
        },
        $gte: function $gte(n, t, r) {
          var e = r.comparable,
            o = r.compare;
          return function (t) {
            return o(e(t), e(n)) >= 0;
          };
        },
        $lt: function $lt(n, t, r) {
          var e = r.comparable,
            o = r.compare;
          return function (t) {
            return o(e(t), e(n)) < 0;
          };
        },
        $lte: function $lte(n, t, r) {
          var e = r.comparable,
            o = r.compare;
          return function (t) {
            return o(e(t), e(n)) <= 0;
          };
        },
        $in: function $in(n, t, r) {
          var o = r.comparable;
          return function (t) {
            if (!(t instanceof Array)) {
              var u = o(t);
              if (u === t && "object" === e(t)) for (f = n.length; f--;) if (String(n[f]) === String(t) && "[object Object]" !== String(t)) return !0;
              if (void 0 === u) for (f = n.length; f--;) if (null == n[f]) return !0;
              for (f = n.length; f--;) {
                var i = p(h(c(n, f), r), u, f, n);
                if (i && "[object Object]" !== String(i) && "[object Object]" !== String(u)) return !0;
              }
              return !!~n.indexOf(u);
            }
            for (var f = t.length; f--;) if (~n.indexOf(o(c(t, f)))) return !0;
            return !1;
          };
        },
        $nin: function $nin(n, t, r) {
          var e = g.$in(n, t, r);
          return function (n, t, r, o) {
            return !e(n, t, r, o);
          };
        },
        $mod: function $mod(n) {
          return function (t) {
            return t % n[0] == n[1];
          };
        },
        $ne: function $ne(n, t, r) {
          var e = g.$eq(n, t, r);
          return l(function (n, t, r, o) {
            return !e(n, t, r, o);
          });
        },
        $and: function $and(n, t, r) {
          return n.map(d(r));
        },
        $all: function $all(n, t, r) {
          return g.$and(n, t, r);
        },
        $or: function $or(n, t, r) {
          return n.map(d(r));
        },
        $nor: function $nor(n, t, r) {
          return n.map(d(r));
        },
        $not: function $not(n, t, r) {
          var e = d(r)(n);
          return function (n, t, r) {
            return !p(e, n, t, r);
          };
        },
        $type: function $type(n) {
          return function (t, r, e) {
            return null != t && (t instanceof n || t.constructor == n);
          };
        },
        $regex: function $regex(n, t) {
          return new RegExp(n, t.$options);
        },
        $where: function $where(n) {
          if ("function" == typeof n) return n;
          throw new Error('In CSP mode, sift does not support strings in "$where" condition');
        },
        $elemMatch: function $elemMatch(n, t, r) {
          return d(r)(n);
        },
        $exists: function $exists(n) {
          return !!n;
        }
      };
    function v(n, t) {
      return {
        options: n,
        validate: t
      };
    }
    function $(n, t) {
      var r = n.keyPath,
        e = n.child,
        o = n.query,
        i = [];
      if (function n(t, r, e, o, i) {
        if (e === r.length || null == t) return void i.push([t, r[e - 1], o]);
        var f = c(r, e);
        if (u(t) && isNaN(Number(f))) for (var a = 0, l = t.length; a < l; a++) n(c(t, a), r, e, t, i);else n(c(t, f), r, e + 1, t, i);
      }(t, r, 0, t, i), 1 === i.length) {
        var f = i[0];
        return p(e, f[0], f[1], f[2]);
      }
      for (var a = o && void 0 !== o.$ne, l = a, s = 0; s < i.length; s++) {
        var g = i[s],
          v = p(e, g[0], g[1], g[2]);
        a ? l &= v : l |= v;
      }
      return l;
    }
    function b(n, t, r) {
      return v({
        keyPath: n,
        child: t,
        query: r
      }, $);
    }
    function d(n) {
      var t = n.comparable,
        r = n.expressions,
        e = function e(n) {
          var t;
          return (!n || !(t = n) || t.constructor !== Object && t.constructor !== Array && "function Object() { [native code] }" !== t.constructor.toString() && "function Array() { [native code] }" !== t.constructor.toString() || t.toJSON) && (n = {
            $eq: n
          }), n;
        },
        o = function o(e) {
          e = t(e);
          var o = [];
          for (var i in e) {
            var f = e[i];
            if ("$options" !== i) {
              var c = s[i] || n && r && r[i];
              if (c) g[i] && (f = g[i](f, e, n)), o.push(v(t(f), c));else {
                if (36 === i.charCodeAt(0)) throw new Error("Unknown operation " + i);
                var a = i.split(".");
                o.push(b(a, u(f), f));
              }
            }
          }
          return 1 === o.length ? o[0] : v(o, s.$and);
        },
        u = function u(n) {
          return n = e(n), -1 === function n(t, r) {
            if (!i(t)) return r;
            for (var e in t) r.push(e), n(t[e], r);
            return r;
          }(n, []).join(",").search(/[$.]/) ? v(n, y) : o(n);
        };
      return function (n) {
        return o(e(n));
      };
    }
    function y(n, t) {
      if (Object.prototype.toString.call(n) !== Object.prototype.toString.call(t)) return !1;
      if (i(n)) {
        if (Object.keys(n).length !== Object.keys(t).length) return !1;
        for (var r in n) if (!y(n[r], t[r])) return !1;
        return !0;
      }
      if (u(n)) {
        if (n.length !== t.length) return !1;
        for (var e = 0, o = n.length; e < o; e++) if (!y(n[e], t[e])) return !1;
        return !0;
      }
      return n === t;
    }
    function h(n, t) {
      var r = d(t)(n);
      return t && t.select && (r = {
        options: r,
        validate: function validate(n, r, e, o) {
          return p(n, r && t.select(r), e, o);
        }
      }), r;
    }
    function m(n, t) {
      var r = h(n, t = Object.assign({
        compare: j,
        comparable: O
      }, t));
      return function (n, t, e) {
        return p(r, n, t, e);
      };
    }
    function j(n, t) {
      if (y(n, t)) return 0;
      if (e(n) === e(t)) {
        if (n > t) return 1;
        if (n < t) return -1;
      }
    }
    function O(n) {
      return n instanceof Date ? n.getTime() : u(n) ? n.map(O) : n && "function" == typeof n.toJSON ? n.toJSON() : n;
    }
  }]);
});